import { useMutation, useQuery } from 'react-query'
import { normalFetch } from '../../fetch-api/get'
import { putApi } from '../../fetch-api/put'
import { useQueryContext } from '../../../contexts/query'

export const accountingKeys = {
	getAccountingConfig: 'getAccountingConfig',
	setAccountingConfig: 'setAccountingConfig',
	setOwnerAccount: 'setOwnerAccount',
	getOwnerAccount: 'getOwnerAccount',
}

export const useGetAccountingConfig = () => {
	return useQuery({
		queryFn: () => normalFetch('settings/manualAccounting'),
		queryKey: [accountingKeys.getAccountingConfig],
		select: (res) => res?.data?.data,
	})
}

export const useSetAccountingConfig = (onSuccess) => {
	const { queryClient, setToast } = useQueryContext()

	return useMutation({
		mutationFn: (payload) => putApi(payload, 'settings/manualAccounting'),
		mutationKey: [accountingKeys.setAccountingConfig],
		onSuccess: () => {
			queryClient.invalidateQueries([accountingKeys.getAccountingConfig])
			setToast({
				message: 'operation-success',
				show: true,
			})
			onSuccess()
		},
	})
}

export const useGetOwnerAccounts = () => {
	return useQuery({
		queryFn: () => normalFetch('settings/ownerAccount'),
		queryKey: [accountingKeys.getOwnerAccount],
		select: (res) => res?.data?.data,
	})
}

export const useSetOwnerAccounts = (onSuccess) => {
	const { queryClient, setToast } = useQueryContext()

	return useMutation({
		mutationFn: (payload) => putApi(payload, 'settings/ownerAccount'),
		mutationKey: [accountingKeys.setOwnerAccount],
		onSuccess: () => {
			queryClient.invalidateQueries([accountingKeys.getOwnerAccount])
			setToast({
				message: 'operation-success',
				show: true,
			})
			onSuccess()
		},
	})
}
